import { useState } from "react";
import {
  getContainerPositionService,
  getOutputContainerPositionService,
  updateContainerPositionsService,
  updateOutputContainerPositionsService,
} from "../api/services/container";
import { v4 as uuid } from "uuid";
import handleMessages from "../utils/HandleMessages";

const useContainer = () => {
  const [containers, setContainers] = useState([]);

  const getContainerPosition = async () => {
    const res = await getContainerPositionService();
    if (res.success) {
      const containers = res.data.response;
      getNewContainers(containers, "entrada");
    }
  };

  const updateContainerPosition = async (newPositions, codigo_posicion, log_usu_id) => {
    const res = await updateContainerPositionsService(newPositions, codigo_posicion, log_usu_id);
    return handleMessages(res);
  };

  const getNewContainers = (containers, type) => {
    console.log("containers", containers);
    const newContainers = containers.map((container) => ({
      activo: true,
      title: `Muelle ${container.nombre_muelle}  ${container.bodega ? `(${container.bodega})` : ""}`,
      codigo_muelle: container.codigo_muelle,
      nombre_muelle: container.nombre_muelle,
      _id: uuid(),
      cards: container.contenedores.map((item) => ({
        titulo:
          type === "entrada"
            ? item.nombre_transportista
            : item.wms_solicitud_salida.nombre_consig_segun_duca,
        codigo: item.cac_numero || item.nombre_cliente,
        id: String(item.codigo_posicion),
        position: item.orden,
        porcentaje: item.porcentaje,
        extendedProps: { ...item },
        codigo_muelle: item.codigo_muelle,
        codigo_pilotocarta:
          type === "entrada"
            ? item.codigo_pilotocarta
            : item.wms_solicitud_salida.codigo_solicitud_salida,
      })),
    }));
    setContainers(newContainers);
  };

  // SALIDAS

  const getOutputContainerPosition = async () => {
    const res = await getOutputContainerPositionService();
    if (res.success) {
      const containers = res.data.response;
      getNewContainers(containers, "salida");
    }
  };

  const updateOutputContainerPositions = async(newPositions) => {
    const res = await updateOutputContainerPositionsService(newPositions);
    return res.success;
  }

  return {
    containers,
    getContainerPosition,
    setContainers,
    updateContainerPosition,
    getOutputContainerPosition,
    updateOutputContainerPositions
  };
};

export default useContainer;
